import { CoreError } from "./core-error";

export enum AlertErrorAction {
    CANCEL = "cancel",
    RELOAD = "reload",
    BACK_TO_PROJECT_LIST = "backToProjectList",
    BACK_TO_PLAN_LIST = "backToPlanList",
    DOWNGRADE_DATABASE = "downgradeDatabase",
}

export class AlertError extends CoreError {
    constructor(
        public title: string,
        public content: string | string[],
        public action?: AlertErrorAction,
    ) {
        super();
        this.name = this.constructor.name;
    }
}
